import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isOpen: false,
};

const trafficUserDetailSidebarSlice = createSlice({
  name: 'trafficUserDetailSidebar',
  initialState,
  reducers: {
    openTrafficUserDetailSidebar: (state) => {
      state.isOpen = true;
    },
    closeTrafficUserDetailSidebar: (state) => {
      state.isOpen = false;
    },
    toggleTrafficUserDetailSidebar: (state) => {
      state.isOpen = !state.isOpen;
    },
  },
});

export const {
  openTrafficUserDetailSidebar,
  closeTrafficUserDetailSidebar,
  toggleTrafficUserDetailSidebar,
} = trafficUserDetailSidebarSlice.actions;

export const selectIsTrafficUserDetailSidebarOpen = (state) => state.trafficUserDetailSidebar.isOpen;

export default trafficUserDetailSidebarSlice.reducer; 